module.exports = __webpack_public_path__ + "img/logo.4f52ee09.png";